export enum ReferenceFeatures {
    CHEMICAL = "CHEMICAL",
    MICRO = "MICRO",
    FG = "FG",
    OTHERS = "OTHERS"
}

